/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
// material
// styles
import injectSheet from 'react-jss'
import styles from './emojireaction_styles'
import Emoji from '../emoji/emoji'

const sizeOptions = {
  SMALL: 14,
  MEDIUM: 16,
  LARGE: 18
}


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : COMPONENTS - EMOJI ~~~~~~~~~~ ========== */
const EmojiReaction = injectSheet(styles)(({ size = 'MEDIUM', name, type, count = 0, classes, darkMode }) => {

  return (
    <div className={`${classes.emojireaction}`}>
      <Emoji isDark={darkMode} size={sizeOptions[size]} name={name} type={type} />
      <span>{count}</span>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EmojiReaction